// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"0f737f88","832":"61e76887","900":"b9a0442e"}[chunkId] + ".chunk.js";
};